<template>
  <div>
    <!--Breadcrumb button-->
    <breadcrumb-button>
      <template #beforeDropdown>
        <b-button variant="success" class="btn-icon" v-b-tooltip v-bind:title="$t('operations.add')" @click="onMailTemplateSelected(null)">
          <i class="fa-solid fa-mail-bulk"></i>
        </b-button>
      </template>
      <template #items>
        <b-dropdown-item @click="openColumnsModal">
          <feather-icon
              icon="CheckSquareIcon"
              size="16"
          />
          <span class="align-middle ml-50">{{ $t('columns.self') }}</span>
        </b-dropdown-item>
      </template>
    </breadcrumb-button>
    <!--Filters-->
    <filter-card  v-model="filter" v-bind:fields="filterFields" search/>
    <!--Table Card-->
    <b-card no-body>
      <b-card-header class="pb-50">
        <h5>{{$t("menu.mailTemplates")}}</h5>
      </b-card-header>
      <b-card-body>
        <mailTemplates-table ref="mailTemplateTable" v-bind:filters="filter" v-bind:columns="columns" :has-selection="false" @selected="onMailTemplateSelected" :lazy="true"/>
      </b-card-body>
    </b-card>
    <!--Modal-->
    <columns-modal ref="columns-modal" column-key="mailTemplates" v-model="columns"
                   v-bind:columns-names="columnsNames" />
    <mailTemplate-modal ref="mailTemplate-modal" />
  </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'
import BreadcrumbButton from '@/components/widget/breadcrumbButton'
import MailTemplateSearchRequest from '@/model/mailTemplate/MailTemplateSearchRequest'
import ColumnsModal from '@/components/modal/columnsModal'
import MailTemplate from '@/model/mailTemplate/MailTemplate'
import mixinPermissions from '@/components/mixin/mixinPermissions'
import mixinBase from '@/components/mixin/mixinBase'
import MailTemplateModal from '@/components/modal/mailTemplateModal'
import FilterCard from '@/components/widget/FilterCard'
import MailTemplateFilterFields from '@/model/filter/MailTemplateFilterFields'
import MailTemplatesTable from '@/components/tables/MailTemplatesTable'

export default {
  name: 'MailTemplatesView',
  components: {MailTemplatesTable, FilterCard, MailTemplateModal, ColumnsModal, BreadcrumbButton },
  mixins: [mixinBase,mixinPermissions],
  data() {
    return {
      columnsNames: Object.keys(MailTemplate()),
      filter: MailTemplateSearchRequest(),
      filterLoaded: false,
      columns: [],
      filterFields: null,
    }
  },
  async created() {
    await this.refreshData()
    this.filterFields = MailTemplateFilterFields();
  },
  computed: {
    ...mapGetters('data', ['allOrganizations']),
  },
  methods: {
    ...mapActions('mailTemplate', ['refreshData']),
    openColumnsModal() {
      this.$refs['columns-modal'].showModal()
    },
    onMailTemplateSelected(selectedId) {
      // console.log("onMailTemplateSelected", selectedId)
      this.$refs['mailTemplate-modal'].showModal(selectedId)
    },
  }
}
</script>

<style>
.style-chooser .vs__search::placeholder,
.style-chooser .vs__dropdown-toggle,
.style-chooser .vs__dropdown-menu {
  background: #dfe5fb;
  border: none;
  color: #394066;
  text-transform: lowercase;
  font-variant: small-caps;
  height: 10px;
}
</style>
